import Accordion from "./components/accordion";
import Toggler from "./components/toggler";
import './pricing';


document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelectorAll('.accordion').length > 0) {
		new Accordion('.accordion');
	}
	
	if (document.querySelectorAll('[data-toggle]').length > 0) {
		new Toggler('[data-toggle]');
	}

	
	function intersect(items) {
		items.forEach((item) => {
			if(item.isIntersecting) {
				item.target.classList.remove('preload');
				item.target.classList.add('loaded');
			}
		});
	  }
	
	  let options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.1
	  }
	  const observer = new IntersectionObserver(intersect, options);
	  const sections = document.querySelectorAll('.fade-in, .slide-up, .slide-left, .slide-down, .wp-block-media-text');
	
	  sections.forEach((item) => {
		  item.classList.add('preload');
		  observer.observe(item);
	  });
	
});
